import {useContext} from 'react'

import PropTypes from 'prop-types'

import AtomButton, {
  atomButtonColors,
  atomButtonDesigns,
  atomButtonShapes,
  atomButtonSizes
} from '@s-ui/react-atom-button'
import Context from '@s-ui/react-context'
import {useMediaQuery, useMediaQueryBreakpoints} from '@adv-mt/mt-layout-render-media-query'

import {useTracking} from '../useTracking.js'
import {PAGE_STATE} from '../utils.js'

export const UnsubscribeEmailsButtons = ({handleSaveNewSubscriptions, pageState = '', isDisabled}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const isMobile = config.get('isMobile')
  const {LOADING, SUCCESS} = PAGE_STATE

  const {trackLinkClicked} = useTracking()

  const initialMediaQueryMatch = {
    defaultMatches: !isMobile
  }
  const isTabletOrWider = useMediaQuery(useMediaQueryBreakpoints.md, initialMediaQueryMatch)

  const handleLink = () => {
    trackLinkClicked()
    window.location.href = i18n.t('NAVIGATION_USER_COCHES_EDIT_URL')
  }
  const hideSaveButton = pageState === SUCCESS

  return (
    <div className="mt-UserUnsubscribeEmails-buttonsContainer">
      {!hideSaveButton && (
        <AtomButton
          color={atomButtonColors.ACCENT}
          disabled={isDisabled}
          fullWidth={!isTabletOrWider}
          isLoading={pageState === LOADING}
          onClick={handleSaveNewSubscriptions}
          shape={atomButtonShapes.CIRCULAR}
          size={atomButtonSizes.LARGE}
        >
          {i18n.t('COMMON.SAVE')}
        </AtomButton>
      )}
      <div className="mt-UserUnsubscribeEmails-infoLink">
        <AtomButton
          design={atomButtonDesigns.LINK}
          fullWidth
          onClick={handleLink}
          shape={atomButtonShapes.CIRCULAR}
          size={atomButtonSizes.LARGE}
        >
          {i18n.t('UNSUBSCRIBE_EMAILS_PAGE.BUTTONS.INFO_LINK')}
        </AtomButton>
      </div>
    </div>
  )
}

UnsubscribeEmailsButtons.displayName = 'UnsubscribeEmailsButtons'
UnsubscribeEmailsButtons.propTypes = {
  handleSaveNewSubscriptions: PropTypes.func,
  isDisabled: PropTypes.bool,
  pageState: PropTypes.string
}
